
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import {
    IfComp,
    PanelSectionTitle
} from '../../../core';

import ObjectDetailAttribute from './ObjectDetailAttribute';

const ObjectDetailInfo = ({
    dataModel,
    object,
    titleVisible
}) => {

    const classNames = mergeStyleSets({
        ObjectDetailInfo: {
        },
        title: {
            paddingTop: 4,
            paddingBottom: 4,
            fontWeight: 'bold',
            color: '#999999'
        },
        attributes: {
        }
    });

    return (
        <Stack className={classNames.ObjectDetailInfo} tokens={{childrenGap: 8}}>
            <IfComp cond={titleVisible !== false}>
                <Stack.Item>
                    <PanelSectionTitle title={dataModel.title} />
                </Stack.Item>
            </IfComp>
            <Stack className={classNames.attributes}>
                {dataModel.attributes.map(item => {
                    return (
                        <ObjectDetailAttribute
                            key={item.name}
                            attribute={item}
                            dataModel={dataModel}
                            value={object.attributes[item.name]}
                        />
                    );
                })}
            </Stack>
        </Stack>
    );
}

export default ObjectDetailInfo;
